import { useEffect, useState } from 'react';
import FormGroup from './FormGroup';
const InputPhoneNumber = ({
    value,
    name,
    label,
    isRequired,
    requirementText,
    showError,
    externalErrorMessage,
    onChange,
    placeholder,
    inlineStyle = {},
    showWarningIcon = false,
}) => {
    const [isValid, setIsValid] = useState(true);
    const [errorText, setErrorText] = useState('');

    const checkValidity = number => number?.length === 10;

    const handleInputChange = e => {
        const { value: phoneNumber, maxLength } = e.target;
        let number = phoneNumber.replace(/[^0-9]/g, '');
        number = number.slice(0, maxLength);
        e.target.value = number;
        const valid = checkValidity(number);
        setIsValid(valid);
        onChange(e, valid);
    };

    useEffect(() => {
        let text = externalErrorMessage || '';
        if (isRequired && !value) {
            text = requirementText || 'Phone number is required';
        } else if (showError && !isValid) {
            text = 'A 10 digit phone number is required';
        }
        setErrorText(text);
    }, [externalErrorMessage, isRequired, value, showError, isValid, requirementText]);

    const hasError = showError && (!isValid || errorText);
    return (
        <FormGroup
            label={label}
            name={name}
            showError={showError}
            externalErrorMessage={
                hasError && errorText ? (
                    <span className="error-message">
                        {showWarningIcon && (
                            <span role="img" aria-label="Warning">
                                <img
                                    className="warning-icon"
                                    src="/img/frontend/warning.svg"
                                    alt="Required field"
                                    width={24}
                                    height={24}
                                />
                            </span>
                        )}{' '}
                        {errorText}
                    </span>
                ) : null
            }
            required={isRequired}
        >
            <input
                value={value}
                type="tel"
                id={name}
                name={name}
                maxLength={10}
                className={`form-control ${hasError ? ' error' : ''}`}
                placeholder={placeholder}
                style={inlineStyle}
                onChange={handleInputChange}
            />
        </FormGroup>
    );
};

export default InputPhoneNumber;
